module.exports = __webpack_public_path__ + "static/media/google_badge_192.4f6a1c1e.svg";